module.exports = __webpack_public_path__ + "static/media/jugador.73e9f5a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jugador.jpg
// module id = 1298
// module chunks = 0